import {
  Button,
  Card,
  Col,
  Form,
  Icon,
  Input,
  notification,
  Popconfirm,
  Row,
  Select,
  Table,
  Tag,
  Tooltip
} from 'antd'
import async from 'async'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import {
  CustomCkEditor,
  InputBox
} from '../../../../components/_utils/appUtils'
import { getUrlParams,getPushPathWrapper } from '../../../../routes'
import { AddDoiAbstractFxn } from '../actions/index'
import { searchKeyword } from '../../../editArticle/actions'
import { getSingleAbstractAction } from '../actions'
import AddAffiliate from '../../../editArticle/addAffiliate'
// import AddKeyword from './addKeywordDrawer'
import EditAffiliate from '../../../editArticle/editAffiliate'

const { Option } = Select
const $ = window.$

@Form.create()
class AddDoiAbstract extends PureComponent {
  state = {
    edit: false,
    fileKey: moment(),
    ckeditorKey: moment() + 1,
    affiliationData: [],
    keywords: [],
    featuredImage: '',
    inputVisible: false,
    inputValue: '',
    loop: null,
    authors: [],
    noOfAuthors: null,
    page: 1,
    valGet: false,
    keywordList: [],
    editVal: {},
    indexVal1: null,
    abstractNo: null,
    abstractId: null,
    superScriptList: [],
    currentStatus: '',
    doiTitle: '',
    doiAbstract: ''
  }

  keywordEvents = {
    getKeyword: async value => {
      if (value) {
        let { data } = await searchKeyword({ keyword: value })
        if (data) {
          this.setState({ keywordList: data })
        }
      }
    },
    chooseKeyword: value => {
      let clData = _.clone(this.state.keywords)
      let clDataList = _.clone(this.state.keywordList)
      let findData = _.find(clDataList, item => {
        return item._id == value.key
      })
      clData.push({
        keywordId: findData._id,
        keyword: findData.keyword,
        slugKeyword: findData.slugKeyword
      })
      this.setState({
        keywords: clData,
        keywordList: []
      })
    },
    removeKeyword: id => {
      let clData = _.clone(this.state.keywords)
      clData = _.reject(clData, item => {
        return item.keywordId == id
      })
      this.setState({
        keywords: clData
      })
    }
  }

  events = {
    onCloseKeyword: () => {
      this.setState({ open4: false })
    },
    showKeywordDrawer: () => {
      this.setState({ open4: true })
    }
  }

  constructor(props) {
    super(props)
  }

  stickyHeader = () => {
    $(window).scroll(function () {
      let classCheck = $('aside').hasClass('ant-layout-sider-collapsed')
        ? 'fixedColl'
        : 'fixed'
      if ($(window).scrollTop() >= 250) {
        $('.sticky-header').addClass(classCheck)
        $('.headerPanel').addClass('sticky-header-bg')
      } else {
        $('.sticky-header').removeClass('fixedColl fixed')
        $('.headerPanel').removeClass('sticky-header-bg')
      }
    })
  }

  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }

  oncloseEditAffiliate = () => {
    this.setState({ openEdit: false })
  }

  showDrawerEditAffiliate = (val, index) => {
    this.setState({ openEdit: true, editVal: val, indexVal1: index })
  }

  updateAffiliate = row => {
    let cloneData = _.clone(this.state.affiliationData)
    cloneData[row.index] = row
    this.setState({ affiliationData: cloneData, openEdit: false })
  }

  loopVal = noOfAuthors => {
    let { affiliationData } = this.state
    noOfAuthors = parseInt(noOfAuthors)
    let authors = []
    let superScriptList = ['*', '#']
    for (let i = 0; i < noOfAuthors; i++) {
      authors.push({
        name: '',
        email: '',
        script: [],
        orchId: ''
      })
    }
    for (let i = 0; i < affiliationData.length; i++) {
      superScriptList.push(i + 1)
    }
    this.setState({ authors, noOfAuthors, superScriptList })
  }

  authorsUpdate = (data, index) => {
    let { authors } = this.state
    let cloneAuth = _.clone(authors)
    if (cloneAuth[index]) {
      cloneAuth[index] = { ...cloneAuth[index], ...data }
      this.setState({ authors: cloneAuth })
    }
  }

  addAffiliateData = data => {
    let cloneData = _.clone(this.state.affiliationData)
    cloneData.push(data)
    this.setState(
      { affiliationData: cloneData },
      () => {
        let { affiliationData } = this.state
        let superScriptList = []
        for (let i = 0; i < affiliationData.length; i++) {
          superScriptList.push(i + 1)
        }
        this.setState({ superScriptList })
      }
    )
  }

  onClose1 = () => {
    this.setState({ open1: false })
  }

  showDrawer1 = (item, index) => {
    this.setState({ open1: true })
  }

  handleDeleteAffilation = key => {
    const newData = this.state.affiliationData.filter(
      (item, index) => index !== key
    )
    let superScriptList2 = []
    for (let i = 0; i < newData.length; i++) {
      superScriptList2.push(i + 1)
    }
    this.setState({ superScriptList: superScriptList2, affiliationData: newData })
  }

  handleSubmit = async e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let {
          authors,
          noOfAuthors,
          keywords,
          affiliationData,
          doiAbstract,
          doiTitle,
          featuredImage,
          abstractId,
          currentStatus
        } = this.state

        if (!doiTitle) {
          notification.error({
            message: 'Required',
            description: 'Enter Final Abstract Title'
          })
          return
        }

        if (!keywords || (keywords && !keywords.length)) {
          notification.error({
            message: 'Required',
            description: 'Enter Keywords'
          })
          return
        }
        if (doiAbstract === '') {
          notification.error({
            message: 'Required',
            description: 'Enter Final Abstract'
          })
          return
        }

        let fd = await new FormData()
        let obj = {
          ...valData,
          abstractId,
          doiAuthors: authors,
          noOfAuthors,
          doiKeywordList: keywords,
          affiliationData,
          doiAbstract,
          doiTitle
        }

        if (featuredImage && featuredImage.name) {
          fd.append('featuredImage', featuredImage)
        }
        if (currentStatus == 'Accepted Abstract') {
          obj.status = 'DOI'
        }

        fd.append('obj', JSON.stringify(obj))

        let resp = await dispatch(AddDoiAbstractFxn(fd))
        if (resp && resp.success) {
          notification.success({
            message: resp.message || 'Abstract Successfully Finalized'
          })
          dispatch(getPushPathWrapper('onlineAbstractsGroup.DOIAbstract'))
        }
      }
    })
  }

  componentDidMount() {
    this.stickyHeader()
    this.loadAbstractData()
  }

  loadAbstractData = () => {
    let data = getUrlParams('onlineAbstractsGroup.addDoiAbstract', this.props.pathname)
    console.log(data,"data")
    if (!!data) {
      let { id } = data
      this.setFormValuesFxn(id)
    }
  }

  setFormValuesFxn = async id => {
    const { dispatch, form } = this.props
    let { error, data } = await dispatch(getSingleAbstractAction(id))
    console.log("Abstract Data loaded from DB:", data);

    if (error) {
      notification.error({
        message: 'Error Loading Data'
      })
    } else {
      let obj = {
        doiProcessDate: moment(data.doiProcessDate || new Date()),
        doiKeywordList: data.doiKeywordList
      }
      this.props.form.setFieldsValue({ ...obj })

      let superScriptList = ['*', '#']
      if (data.affiliationData && data.affiliationData.length) {
        for (let i = 0; i < data.affiliationData.length; i++) {
          superScriptList.push(i + 1)
        }
      }

      let stateObj = {
        abstractNo: data.abstractNo,
        abstractId: data._id,
        // The Fallback Logic: Check for DOI fields, fallback to original fields
        doiTitle: data.doiTitle ? data.doiTitle : data.titleOfAbstract,
        doiAbstract: data.doiAbstract ? data.doiAbstract : data.abstract,
        noOfAuthors: data.noOfAuthors ? data.noOfAuthors : '',
        superScriptList: superScriptList,
        authors: data.doiAuthors ? data.doiAuthors : [],
        affiliationData: data.affiliationData ? data.affiliationData : [],
        keywords: data.doiKeywordList ? data.doiKeywordList : [],
        oldFeatureImage: data.featuredImage ? data.featuredImage : {},
      }

      this.setState({ ...stateObj, currentStatus: data.status })
    }
  }

  render() {
    const {
      form: { getFieldDecorator },
      loading
    } = this.props
    const {
      authors,
      oldFeatureImage,
      superScriptList
    } = this.state

    const formItemLayout = {
      labelCol: { xs: { span: 24 }, sm: { span: 18 }, md: { span: 14 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 24 }, md: { span: 24 } }
    }

    const inputSchema = {
      fields: [
        {
          label: 'Date',
          key: 'doiProcessDate',
          required: true,
          placeholder: 'Date',
          type: 'date',
          span: 8
        },
        {
          label: 'Featured Image',
          key: 'featuredImage',
          span: 8,
          type: 'file',
          customField: (
            <InputBox title={`Featured Image`} className={'rowFlex'}>
              <Input
                width='100%'
                type={'file'}
                name={'featuredImage'}
                id={'featuredImage'}
                className={'form-control'}
                key={this.state.fileKey}
                onChange={e => {
                  this.chooseDocument(e)
                }}
              />
              {oldFeatureImage && oldFeatureImage.path ? (
                <a
                  className={'linkBtn'}
                  target={'_blank'}
                  href={oldFeatureImage.path}>
                  <Icon type={'eye'} />
                </a>
              ) : null}
            </InputBox>
          )
        },
        {
          label: 'Abstract Title',
          key: 'doiTitle',
          span: 24,
          customField: (
            <CustomCkEditor
              title={'Abstract Title'}
              basic={true}
              height={100}
              html={this.state.doiTitle}
              onChange={data => {
                this.setState({ doiTitle: data })
              }}
            />
          )
        },
        {
          label: 'Abstract',
          key: 'doiAbstract',
          type: 'ckeditor',
          span: 24,
          customField: (
            <CustomCkEditor
              html={this.state.doiAbstract}
              title={'Abstract'}
              onChange={data => {
                this.setState({ doiAbstract: data })
              }}
              height={500}
            />
          )
        }
      ]
    }

    const columns = [
      {
        title: 'Serial no',
        name: 'serial',
        key: 'serial',
        render: (text, record, index) => <div>{index + 1}</div>,
        width: 200
      },
      {
        title: 'Affiliate',
        name: 'affiliate',
        key: 'affiliate',
        dataIndex: 'affiliate'
      },
      {
        title: 'Action',
        name: 'action',
        key: 'action',
        dataIndex: 'action',
        width: 100,
        render: (item, index, indexValue) => (
          <>
            <Tooltip title='Edit information' style={{ marginRight: '20px' }}>
              <Button
                style={{ border: 20 }}
                shape='circle'
                onClick={e => this.showDrawerEditAffiliate(index, indexValue)}
                icon={'edit'}
              />
            </Tooltip>
            <Popconfirm
              title={`Are you Sure, You want to delete?`}
              onConfirm={e => this.handleDeleteAffilation(indexValue)}
              okText='Yes'
              cancelText='No'>
              <Button shape='circle' icon={'delete'} />
            </Popconfirm>
          </>
        )
      }
    ]

    return (
      <PageHeaderWrapper
        className={'articleHeader'}
        title={
          <div className={'sticky-header'}>
            <div className={'headerPanel'}>
              <div className='titleDiv'>
                {this.state.abstractNo
                  ? `Add Doi Abstract | Abstract No ${this.state.abstractNo}`
                  : 'Add DOI Abstract'}
              </div>
            </div>
          </div>
        }>
        <Card bordered={true} className={'doi-form'}>
          <Form onSubmit={this.handleSubmit} hideRequiredMark className={'inputForm'} noValidate={true}>
            <Row gutter={16}>
              {inputSchema.fields.map((item, key) => (
                !item.hidden && (
                  <Col span={item.span ? item.span : 12} md={item.span ? item.span : 12} sm={12} xs={24} key={key}>
                    {item.customField ? (
                      item.customField
                    ) : (
                      <GetEachFormFields
                        item={item}
                        getFieldDecorator={getFieldDecorator}
                        formItemLayout={formItemLayout}
                      />
                    )}
                  </Col>
                )
              ))}
            </Row>

            {/*{this.state.open4 ? (*/}
            {/*  <AddKeyword visible={this.state.open4} onClose={() => this.events.onCloseKeyword()} />*/}
            {/*) : null}*/}

            <Card title={'Keywords'}>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item>
                    <Select
                      value={this.state.keywordList}
                      showSearch={true}
                      filterOption={false}
                      labelInValue
                      onChange={this.keywordEvents.chooseKeyword}
                      onSearch={this.keywordEvents.getKeyword}
                      name='keywords'
                      placeholder='Search Keywords'>
                      {this.state.keywordList &&
                      this.state.keywordList.map(item => (
                        <Option key={item._id}>{item.keyword}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Button
                    style={{ marginTop: 3 }}
                    onClick={() => this.events.showKeywordDrawer()}
                    className='ant-btn ant-btn-primary'>
                    Add Keyword
                  </Button>
                </Col>
                <Col span={24}>
                  {this.state.keywords &&
                  this.state.keywords.map((item, i) => (
                    <Tag key={i}>
                      {item.keyword}
                      <a onClick={() => this.keywordEvents.removeKeyword(item.keywordId)}>
                        <Icon type={'close'} />
                      </a>
                    </Tag>
                  ))}
                </Col>
              </Row>
            </Card>

            <Card
              title={'Affiliation'}
              extra={
                <Form.Item name='add' style={{ textAlign: 'right' }}>
                  <Button size='small' onClick={this.showDrawer1} className='ant-btn ant-btn-primary'>
                    Add Affiliation
                  </Button>
                </Form.Item>
              }>
              <Table
                size='small'
                columns={columns}
                className={'figureTable'}
                dataSource={this.state.affiliationData}
                pagination={false}
              />
            </Card>

            <Card title='Authors'>
              <Form.Item label='Enter Number of Authors'>
                <Input
                  style={{ width: '34%' }}
                  value={this.state.noOfAuthors}
                  type={'number'}
                  onChange={e => this.loopVal(e.target.value)}
                />
              </Form.Item>

              {authors && authors.length ? (
                <>
                  {authors.map((item, key) => (
                    <Row key={key} gutter={16}>
                      <Col span={6}>
                        <Form.Item label='Name'>
                          <Input
                            placeholder='Enter Name'
                            value={item.name}
                            onChange={e => this.authorsUpdate({ name: e.target.value }, key)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item label='Email Address'>
                          <Input
                            placeholder='Enter email Address'
                            type={'email'}
                            value={item.email}
                            onChange={e => this.authorsUpdate({ email: e.target.value }, key)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item label='Super Script'>
                          <Select
                            onChange={e => this.authorsUpdate({ script: e }, key)}
                            mode='multiple'
                            value={item.script}
                            placeholder='Please select Super Script'>
                            {superScriptList &&
                            superScriptList.map((item, key) => (
                              <Option key={key} value={item}>{item}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item label='Orch Id'>
                          <Input
                            placeholder='Enter Orch Id'
                            value={item.orchId}
                            onChange={e => this.authorsUpdate({ orchId: e.target.value }, key)}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  ))}
                </>
              ) : null}
            </Card>

            <Form.Item style={{ marginTop: 32 }}>
              <Button type='primary' htmlType='submit'>
                SUBMIT
              </Button>
            </Form.Item>
          </Form>

          <AddAffiliate
            addAffiliateData={this.addAffiliateData}
            visible={this.state.open1}
            onClose={() => this.onClose1()}
          />

          {this.state.openEdit ? (
            <EditAffiliate
              visible={this.state.openEdit}
              updateAffiliate={this.updateAffiliate}
              editVal={this.state.editVal}
              indexVal1={this.state.indexVal1}
              onClose={() => this.oncloseEditAffiliate()}
            />
          ) : null}
        </Card>
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddDoiAbstract)